import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["error", "className", "title", "caption", "options", "defaultValue", "name", "required", "readOnly", "forbidChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useState, useCallback } from "react";
import classnames from "classnames";
import styles from "@/styles/Form.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var RadioField = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classnames;

  var error = props.error,
      className = props.className,
      title = props.title,
      caption = props.caption,
      options = props.options,
      defaultValue = props.defaultValue,
      name = props.name,
      required = props.required,
      readOnly = props.readOnly,
      forbidChange = props.forbidChange,
      _props = _objectWithoutProperties(props, _excluded);

  var _useState = useState(defaultValue),
      selected = _useState[0],
      setSelected = _useState[1];

  var handleChange = useCallback(function (e) {
    setSelected(e.target.value);
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.inputField,
    children: [title && /*#__PURE__*/_jsx("legend", {
      className: classnames(styles.formTitle, (_classnames = {}, _defineProperty(_classnames, styles.required, required), _defineProperty(_classnames, styles.forbidChange, forbidChange), _classnames)),
      children: title
    }), /*#__PURE__*/_jsx("div", {
      className: styles.formGroup,
      children: options.map(function (option, i) {
        return /*#__PURE__*/_jsxs("div", {
          className: classnames(styles.inputField, styles.radio, _defineProperty({}, styles.readOnly, readOnly)),
          children: [/*#__PURE__*/_jsx("input", _objectSpread({
            ref: ref,
            type: "radio",
            name: name,
            id: "".concat(name, "-").concat(option.value),
            className: classnames(styles.radioInput, className),
            value: option.value,
            onChange: handleChange,
            checked: selected == option.value
          }, _props)), /*#__PURE__*/_jsx("label", {
            htmlFor: "".concat(name, "-").concat(option.value),
            tabIndex: "0",
            children: option.label
          })]
        }, "radio-".concat(i));
      })
    }), caption && /*#__PURE__*/_jsx("p", {
      className: styles.caption,
      children: caption
    }), error && /*#__PURE__*/_jsx("span", {
      className: styles.errorMessage,
      children: error
    })]
  });
});
RadioField.displayName = "RadioField";
export default RadioField;